// frontend/src/components/layout/Sidebar.tsx
import { NavLink } from 'react-router-dom';
import { getSidebarGroups } from '../../config/navigation';
import { useAuthStore } from '../../store/authStore';

interface SidebarProps { isOpen: boolean; onClose: () => void; }

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const role = useAuthStore((s) => s.profile?.role);
  const groups = getSidebarGroups(role);

  return (
    <>
      {isOpen && <div className="app-sidebar-backdrop" onClick={onClose} />}
      <aside className={`app-sidebar ${isOpen ? 'open' : ''}`}>
        {groups.map((group, index) => (
          <div key={index} className="app-sidebar-section">
            {group.title && <div className="app-sidebar-section-title">{group.title}</div>}
            {group.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `app-sidebar-item ${isActive ? 'active' : ''}`}
                onClick={onClose}
              >
                <span className="app-sidebar-icon">
                  <item.icon size={20} strokeWidth={2} />
                </span>
                <span className="app-sidebar-label">{item.label}</span>
                {item.badge && (
                  <span className="app-sidebar-badge">{item.badge}</span>
                )}
              </NavLink>
            ))}
          </div>
        ))}
      </aside>
    </>
  );
}
